import "./styles.css";
import { PoemCodecApp } from "./app";
import { serviceWorkerRegistration } from "./service-worker";

const root = document.querySelector<HTMLElement>("#app");
if (!root) throw new Error("Application root is missing.");

void serviceWorkerRegistration().catch((error: unknown) => console.error("Service worker setup failed.", error));

new PoemCodecApp(root);
